import { useState } from "react";
import { API } from 'aws-amplify';
import { getAuthToken } from "../../../utils/AuthUtils";
import { Alert, Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import './styles.scss';

const AddCompanyModal = ({ show, onClose }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [companyId, setCompanyId] = useState("");
    const [capIqCode, setCapIqCode] = useState("");
    const [ticker, setTicker] = useState("");
    const [exchange, setExchange] = useState("");
    const [companyDetails, setCompanyDetails] = useState({});

    const handleClose = () => {
        setLoading(false);
        setError(false);
        setErrorMessage("");
        setCompanyId("");
        setCapIqCode("");
        setTicker("");
        setExchange("");
        setCompanyDetails({});
        onClose();
    }

    const handleAddCompany = async () => {
        setLoading(true);
        setError(false);
        setErrorMessage("");

        if (!companyId || (!ticker && !capIqCode)) {
            setLoading(false);
            setError(true);
            setErrorMessage("Missing required fields. Company ID and Ticker or Cap IQ code are required.");
            return;
        }

        const authToken = await getAuthToken();
        const body = {
            capIqCode: capIqCode,
            ticker: ticker,
            exchange: exchange,
            companyId: companyId
        }

        API.post("AnnualCompensations", "/company-data",
            {
                headers: {
                    'Token': authToken
                },
                body
            }
        ).then(response => {
            setLoading(false);
            setCompanyDetails(response);
        }).catch(error => {
            console.log(error);
            setLoading(false);
            setError(true);
            setErrorMessage("Exception occurred adding company");
        })
    }

    return (
        <div>
            <Modal show={show} onHide={handleClose} size='lg' centered>
                <div className="new-company-container">
                    <Modal.Header closeButton>
                        Add New Company
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col md={3}>
                                <Form.Group controlId="ticker">
                                    <Form.Label>Ticker</Form.Label>
                                    <Form.Control type="text" value={ticker} onChange={(e) => setTicker(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group controlId="exchange">
                                    <Form.Label>Exchange</Form.Label>
                                    <Form.Control type="text" value={exchange} onChange={(e) => setExchange(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group controlId="capIqCode">
                                    <Form.Label>Cap IQ Code</Form.Label>
                                    <Form.Control type="text" value={capIqCode} onChange={(e) => setCapIqCode(e.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col md={3}>
                                <Form.Group controlId="companyId">
                                    <Form.Label>Company ID / CIK</Form.Label>
                                    <Form.Control type="text" value={companyId} onChange={(e) => setCompanyId(e.target.value)} />
                                </Form.Group>
                            </Col>
                        </Row>
                        {error && <Alert dismissible variant="danger" show={error} onClose={() => setError(false)}>{errorMessage}</Alert>}
                        {companyDetails?.companyDetails && <>
                            <Row>
                                <Col md={4}>
                                    <Form.Group controlId="companyName">
                                        <Form.Label>Company Name</Form.Label>
                                        <Form.Control type="text" value={companyDetails.companyDetails.company_name} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group controlId="capIqCode">
                                        <Form.Label>Cap IQ Code</Form.Label>
                                        <Form.Control type="text" value={companyDetails.companyDetails.cap_iq_code} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group controlId="companyId">
                                        <Form.Label>Company ID</Form.Label>
                                        <Form.Control type="text" value={companyDetails.companyDetails.company_id} readOnly />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group controlId="tickerExchange">
                                        <Form.Label>Primary Ticker</Form.Label>
                                        <Form.Control type="text" value={companyDetails?.tickerDetails?.ticker ? companyDetails.tickerDetails.ticker + ":" + companyDetails.tickerDetails.exchange : ""} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col md={8}>
                                    <Form.Group controlId="otherTickers">
                                        <Form.Label>Other Tickers</Form.Label>
                                        <Form.Control type="text" value={""} readOnly />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group controlId="sector">
                                        <Form.Label>Sector</Form.Label>
                                        <Form.Control type="text" value={companyDetails.companyDetails.sector} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col md={8}>
                                    <Form.Group controlId="sector">
                                        <Form.Label>Industry</Form.Label>
                                        <Form.Control type="text" value={companyDetails.companyDetails.primary_industry} readOnly />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group controlId="city">
                                        <Form.Label>City</Form.Label>
                                        <Form.Control type="text" value={companyDetails.companyDetails.city} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group controlId="state">
                                        <Form.Label>State</Form.Label>
                                        <Form.Control type="text" value={companyDetails.companyDetails.state} readOnly />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group controlId="country">
                                        <Form.Label>Country</Form.Label>
                                        <Form.Control type="text" value={companyDetails.companyDetails.country} readOnly />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group controlId="description">
                                        <Form.Label>Description</Form.Label>
                                        <Form.Control type="text" as="textarea" value={companyDetails.companyDetails.description} readOnly />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <Form.Group controlId="public">
                                        <Form.Label>Public</Form.Label>
                                        <Form.Check type="checkbox" checked={companyDetails.companyDetails.public} readOnly />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </>}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={handleAddCompany}>{loading ? <Spinner as="span" animation="grow" size="sm" aria-hidden="true" /> : "Add"}</Button>
                        <Button variant="secondary" onClick={handleClose}>Close</Button>
                    </Modal.Footer>
                </div>
            </Modal>
        </div>
    )
}

export default AddCompanyModal;